// extracted by mini-css-extract-plugin
export default {"Container":"styles_Container__3NvUo","bigtitle":"styles_bigtitle__TDm-I","content":"styles_content__QWBsM","title":"styles_title__CtEp8","numbers":"styles_numbers__Zkyg5"};